import * as bootstrap from 'bootstrap'
import $, { jQuery } from 'jquery'

window.bootstrap = bootstrap;
import 'select2'
// import 'toastr'
// import 'node-waves'
import 'owl.carousel'
// import 'inputmask/dist/inputmask/jquery.inputmask'
import Swal from 'sweetalert2'
import 'jquery-steps/build/jquery.steps.js'
import Choices from '../../custom_node_modules/choices.js'
import { current_lang_short, common_lang_file } from '../js/modules/common.js'
import { initNotifications } from '../js/modules/notifications.js'
import '../js/modules/account_insights.js'
import '../js/modules/transaction_import.js'
// import {fn_form_needs_validation_initialization} from '../js/modules/common_validations.js'
import { TabulatorFull as Tabulator } from 'tabulator-tables'
import '../../node_modules/tabulator-tables/dist/css/tabulator_bootstrap5.min.css'

window.$ = $;

import 'parsleyjs'
import(`../../node_modules/parsleyjs/dist/i18n/${current_lang_short()}.js`)

// custom parsley validator because of localization decimal value separator [,.] issue
// data-parsley-greater-than="0.01"
Parsley.addValidator('greaterThan', {
    validateString: function (value, requirement) {
        if (typeof value === 'string') {
            value = value.replace(',', '.');
        };

        return parseFloat(value) >= requirement;
    },
    requirementType: 'string',
    messages: {
        en: 'This value should be more than %s',
        uk: 'Значення повинно бути більше ніж %s'
    }
});


window.initSelect2 = function (context) {
    context = context || document;

    const localizeCountryOptions = function (selectElement) {
        if (typeof Intl.DisplayNames !== 'function') {
            return;
        }

        const locale = document.documentElement.lang || navigator.language;
        const countryNames = new Intl.DisplayNames([locale], { type: 'region' });

        Array.from(selectElement.options).forEach(function (option) {
            const countryCode = option.value.trim().toUpperCase();
            if (!countryCode) {
                return;
            }
            if (!/^[A-Z]{2}$/.test(countryCode)) {
                option.remove();
                return;
            }

            const localizedName = countryNames.of(countryCode);
            if (localizedName && localizedName !== countryCode) {
                option.text = localizedName;
            }
        });
    };

    const countryFlagTemplate = function (state) {
        if (!state.id) return state.text;

        const code = ($(state.element).data('code') || state.id).toString().trim().toLowerCase();
        if (!/^[a-z]{2}$/.test(code)) return $('<span>').text(state.text);

        const $wrapper = $('<span>').addClass('d-inline-flex align-items-center');
        $('<img>')
            .attr({
                src: `/images/flags/4x3/${code}.svg`,
                alt: '',
                width: 20,
                height: 15,
                'aria-hidden': 'true'
            })
            .addClass('me-2 rounded-1 shadow-sm object-fit-cover flex-shrink-0')
            .appendTo($wrapper);
        $('<span>').text(state.text).appendTo($wrapper);
        return $wrapper;
    };

    const resolveSelect2DropdownParent = function (selectElement) {
        const modalElement = $(selectElement).closest('.modal');
        if (modalElement.length) return modalElement;

        const explicitParent = $(selectElement).data('dropdown-parent');
        if (explicitParent) {
            const $parent = $(selectElement).closest(explicitParent);
            if ($parent.length) return $parent;
            const $globalParent = $(explicitParent);
            if ($globalParent.length) return $globalParent;
        }

        const wrapperParent = $(selectElement).closest('.select2-dropdown-parent, .ms-select2-parent');
        if (wrapperParent.length) return wrapperParent;

        return null;
    };

    const syncSelect2MinWidth = function (selectElement) {
        // NOTE: do NOT read computedWidth here — Select2 has already hidden the original
        // <select> with width:1px !important (.select2-hidden-accessible), so getComputedStyle
        // would return '1px' and collapse the container. Only copy an explicit min-width when
        // it is a real value set by the author (not the browser default of 0px).
        const computedMinWidth = window.getComputedStyle(selectElement).minWidth;
        if (computedMinWidth && computedMinWidth !== '0px') {
            $(selectElement).next('.select2-container').css('min-width', computedMinWidth);
        }
        const selectTitle = $(selectElement).attr('title');
        if (selectTitle) {
            const $container = $(selectElement).next('.select2-container');
            $container.attr('title', selectTitle);
            $container.find('.select2-selection').attr('title', selectTitle);
            $container.find('.select2-selection__rendered').attr('title', selectTitle);
        }
    };

    $(context).find("select.select2-search-disable").each(function () {
        if ($(this).hasClass('select2-hidden-accessible')) {
            try { $(this).select2('destroy'); } catch (e) {}
        }
        $(this).next('.select2-container').remove();

        const options = {
            minimumResultsForSearch: 1 / 0,
            width: '100%'
        };
        const dropdownParent = resolveSelect2DropdownParent(this);
        if (dropdownParent) {
            options.dropdownParent = dropdownParent;
        }

        if ($(this).hasClass('select2-country') || $(this).data('select2-flag')) {
            if ($(this).hasClass('select2-country')) {
                localizeCountryOptions(this);
            }
            options.templateResult = countryFlagTemplate;
            options.templateSelection = countryFlagTemplate;
        } else if (this.dataset.periodCounts) {
            // periods of every year: a search once the list is long, and where the transactions are
            let counts = {};
            try { counts = JSON.parse(this.dataset.periodCounts); } catch (e) { counts = {}; }
            const countTitle = this.dataset.periodCountTitle || '{0}';
            options.minimumResultsForSearch = 8;
            // a compact field on the dashboard keeps the width it was given, so "Жовт 2025" fits on one line
            // and the list stays under the field instead of running off the screen
            if (this.style.width) {
                options.width = this.style.width;
            }
            // in a compact picker the list is wider than the field and opens from its right edge (see .ms-period-picker)
            const picker = this.closest('.ms-period-picker');
            if (picker) {
                options.dropdownAutoWidth = true;
                options.dropdownParent = $(picker);
                // the list is wider than the field: keep it inside the screen whatever side the field is on
                $(this).on('select2:open', function () {
                    window.requestAnimationFrame(function () {
                        const dropdown = picker.querySelector('.select2-container--open .select2-dropdown');
                        if (!dropdown) return;
                        dropdown.style.transform = '';
                        const rect = dropdown.getBoundingClientRect();
                        const gutter = 8;
                        const overRight = rect.right - (document.documentElement.clientWidth - gutter);
                        const overLeft = gutter - rect.left;
                        const shift = overRight > 0 ? -overRight : overLeft > 0 ? overLeft : 0;
                        if (shift !== 0) {
                            dropdown.style.transform = `translateX(${Math.round(shift)}px)`;
                        }
                    });
                });
            }
            options.templateResult = function (state) {
                if (!state.id || counts[state.id] === undefined) return state.text;
                const count = counts[state.id];
                const $row = $('<span class="d-flex align-items-center justify-content-between gap-2"></span>');
                $row.append($('<span></span>').addClass(state.text.length > 16 ? 'text-break' : 'text-nowrap').text(state.text));
                if (count > 0) {
                    $row.append($('<span class="badge bg-light text-body flex-shrink-0"></span>').text(count).attr('title', countTitle.replace('{0}', count)));
                } else {
                    $row.addClass('ms-period-empty');
                }
                return $row;
            };
        } else if ($(this).hasClass('select2-language')) {
            const langFlagMap = { 'uk-ua': 'ua', 'uk': 'ua', 'en-us': 'us', 'en': 'us', 'pl-pl': 'pl', 'pl': 'pl', 'de-de': 'de', 'de': 'de', 'es-es': 'es', 'es': 'es', 'it-it': 'it', 'it': 'it' };
            options.templateResult = function (state) {
                if (!state.id) return state.text;
                const idLower = state.id.toString().toLowerCase();
                const code = langFlagMap[idLower] || idLower.split('-')[0];
                return $(`<span class="d-inline-flex align-items-center"><img src="/images/flags/4x3/${code}.svg" alt="${code}" width="20" height="15" class="me-2 rounded-1 shadow-sm object-fit-cover" onerror="this.style.display='none'" /><span>${state.text}</span></span>`);
            };
            options.templateSelection = function (state) {
                if (!state.id) return state.text;
                const idLower = state.id.toString().toLowerCase();
                const code = langFlagMap[idLower] || idLower.split('-')[0];
                return $(`<span class="d-inline-flex align-items-center"><img src="/images/flags/4x3/${code}.svg" alt="${code}" width="20" height="15" class="me-2 rounded-1 shadow-sm object-fit-cover" onerror="this.style.display='none'" /><span>${state.text}</span></span>`);
            };
        }

        $(this).select2(options);

        syncSelect2MinWidth(this);
        $(this).on('select2:select', function () {
            const selectTitle = $(this).attr('title');
            if (selectTitle) {
                $(this).next('.select2-container').find('.select2-selection__rendered').attr('title', selectTitle);
            }
        });
    });

    let c_lang = common_lang_file();
    $(context).find("select.select2-search-enable").each(function () {
        if ($(this).hasClass('select2-hidden-accessible')) {
            try { $(this).select2('destroy'); } catch (e) {}
        }
        $(this).next('.select2-container').remove();

        const options = {
            minimumResultsForSearch: 0,
            width: '100%',
            language: {
                noResults: function () {
                    return (c_lang && c_lang["noResultsText"]) ? c_lang["noResultsText"] : "No results found";
                },
                searching: function () {
                    return (c_lang && c_lang["searchingText"]) ? c_lang["searchingText"] : "Searching...";
                }
            }
        };
        const dropdownParent = resolveSelect2DropdownParent(this);
        if (dropdownParent) {
            options.dropdownParent = dropdownParent;
        }

        if ($(this).hasClass('select2-country') || $(this).data('select2-flag')) {
            if ($(this).hasClass('select2-country')) {
                localizeCountryOptions(this);
            }
            options.templateResult = countryFlagTemplate;
            options.templateSelection = countryFlagTemplate;
        }

        $(this).select2(options);

        syncSelect2MinWidth(this);
        $(this).on('select2:select', function () {
            const selectTitle = $(this).attr('title');
            if (selectTitle) {
                $(this).next('.select2-container').find('.select2-selection__rendered').attr('title', selectTitle);
            }
        });
    });

    $(context).find("select.select2-tags").each(function () {
        if ($(this).hasClass('select2-hidden-accessible')) {
            try { $(this).select2('destroy'); } catch (e) {}
        }
        $(this).next('.select2-container').remove();

        const placeholder = $(this).attr('data-placeholder') || 'Type or select email...';
        const options = {
            tags: true,
            tokenSeparators: [',', ' ', ';', '\t'],
            width: '100%',
            placeholder: placeholder,
            createTag: function (params) {
                var term = $.trim(params.term);
                var selfEmail = String($(this.element).attr('data-user-email') || $(this.element).data('user-email') || '').trim().toLowerCase();
                if (term === '' || term.indexOf('@') === -1) {
                    return null;
                }
                if (selfEmail && term.toLowerCase() === selfEmail) {
                    return null;
                }
                return {
                    id: term,
                    text: term,
                    newTag: true
                };
            },
            language: {
                noResults: function () {
                    return (c_lang && c_lang["noResultsText"]) ? c_lang["noResultsText"] : "Type email and press Enter";
                }
            }
        };
        const dropdownParent = resolveSelect2DropdownParent(this);
        if (dropdownParent) {
            options.dropdownParent = dropdownParent;
        }

        $(this).select2(options);

        $(this).on('select2:select', function (e) {
            var selfEmail = String($(this).attr('data-user-email') || '').trim().toLowerCase();
            if (selfEmail && e.params && e.params.data && String(e.params.data.id).toLowerCase() === selfEmail) {
                var values = $(this).val() || [];
                var updated = values.filter(function (v) { return String(v).toLowerCase() !== selfEmail; });
                $(this).val(updated).trigger('change');
            }
        });

        $(this).on('change.select2', function () {
            if ($(this).val() && $(this).val().length > 0) {
                $(this).removeClass('is-invalid');
                $(this).next('.select2-container').find('.select2-selection').removeClass('is-invalid');
            }
        });

        syncSelect2MinWidth(this);
        $(this).on('select2:select', function () {
            const selectTitle = $(this).attr('title');
            if (selectTitle) {
                $(this).next('.select2-container').find('.select2-selection__rendered').attr('title', selectTitle);
            }
        });
    });

    // $(context).find(".input-mask").inputmask();
};

window.initSelect2();

let isSessionRecoveryInProgress = false;
const pendingModalSubmitStorageKey = 'ms.pendingModalSubmit.v1';
const pendingModalSubmitTtlMs = 10 * 60 * 1000;

function serializeFormRespectingInputmask(form) {
    const serializedArray = form.serializeArray();
    const formElement = form.get(0);

    if (!formElement) {
        return $.param(serializedArray);
    }

    const maskedFields = Array.from(formElement.elements).filter((field) =>
        field.name &&
        !field.disabled &&
        field.inputmask &&
        typeof field.inputmask.unmaskedvalue === 'function'
    );

    if (!maskedFields.length) {
        return $.param(serializedArray);
    }

    const normalizeMaskedNumericValue = (rawValue) => {
        if (rawValue === undefined || rawValue === null) {
            return '';
        }

        const sanitizedValue = String(rawValue)
            .replace(/\u00A0/g, ' ')
            .replace(/[^0-9,\.\- ]/g, '')
            .replace(/\s+/g, ' ')
            .trim();

        if (!sanitizedValue) {
            return '';
        }

        const lastCommaIndex = sanitizedValue.lastIndexOf(',');
        const lastDotIndex = sanitizedValue.lastIndexOf('.');
        const decimalSeparatorIndex = Math.max(lastCommaIndex, lastDotIndex);

        if (decimalSeparatorIndex === -1) {
            return sanitizedValue.replace(/[ ,\.]/g, '');
        }

        const integerPart = sanitizedValue
            .slice(0, decimalSeparatorIndex)
            .replace(/[ ,\.]/g, '');
        const decimalPart = sanitizedValue
            .slice(decimalSeparatorIndex + 1)
            .replace(/[^0-9]/g, '');

        return decimalPart ? `${integerPart}.${decimalPart}` : integerPart;
    };

    const maskedValuesByName = new Map();
    maskedFields.forEach((field) => {
        if (!maskedValuesByName.has(field.name)) {
            maskedValuesByName.set(field.name, normalizeMaskedNumericValue(field.value));
        }
    });

    serializedArray.forEach((entry) => {
        if (maskedValuesByName.has(entry.name)) {
            entry.value = maskedValuesByName.get(entry.name);
        }
    });

    return $.param(serializedArray);
}

function isLoginResponse(jqXHR) {
    if (!jqXHR) {
        return false;
    }

    if (jqXHR.status === 401 || jqXHR.status === 403) {
        return true;
    }

    const responseUrl = (jqXHR.responseURL || '').toLowerCase();
    if (responseUrl.includes('/identity/account/login') || responseUrl.includes('/account/login')) {
        return true;
    }

    const responseText = typeof jqXHR.responseText === 'string' ? jqXHR.responseText : '';
    return responseText.includes('id="external_logins_form"');
}

function runModalPageInitializers() {
    if (typeof window.initializeTransactionUpsertPage === 'function') {
        window.initializeTransactionUpsertPage();
    }

    if (typeof window.initializeUserAccountUpsertPage === 'function') {
        window.initializeUserAccountUpsertPage();
    }

    if (typeof window.initializeAccountInsights === 'function') {
        window.initializeAccountInsights();
    }

    if (typeof window.initializeFundOperation === 'function') {
        window.initializeFundOperation();
    }

    if (typeof window.fn_apply_global_tooltips === 'function') {
        window.fn_apply_global_tooltips();
    }
}

function savePendingModalSubmission(submission) {
    if (!submission) {
        return;
    }

    try {
        sessionStorage.setItem(pendingModalSubmitStorageKey, JSON.stringify(submission));
    } catch (e) {
        console.warn('Failed to store pending modal submission', e);
    }
}

function readPendingModalSubmission() {
    try {
        const raw = sessionStorage.getItem(pendingModalSubmitStorageKey);
        if (!raw) {
            return null;
        }

        const data = JSON.parse(raw);
        if (!data || !data.createdAt || !data.actionUrl || !data.dataToSend) {
            sessionStorage.removeItem(pendingModalSubmitStorageKey);
            return null;
        }

        if ((Date.now() - data.createdAt) > pendingModalSubmitTtlMs) {
            sessionStorage.removeItem(pendingModalSubmitStorageKey);
            return null;
        }

        return data;
    } catch (e) {
        sessionStorage.removeItem(pendingModalSubmitStorageKey);
        return null;
    }
}

function clearPendingModalSubmission() {
    try {
        sessionStorage.removeItem(pendingModalSubmitStorageKey);
    } catch (e) {}
}

function buildPendingModalSubmission(actionUrl, dataToSend) {
    return {
        actionUrl: actionUrl,
        dataToSend: dataToSend,
        createdAt: Date.now(),
        pageUrl: `${window.location.pathname}${window.location.search}`
    };
}

function redirectToLoginViaReload(options = {}) {
    if (isSessionRecoveryInProgress) {
        return;
    }

    if (options.pendingModalSubmission) {
        savePendingModalSubmission(options.pendingModalSubmission);
    }

    isSessionRecoveryInProgress = true;

    const currentPathAndQuery = `${window.location.pathname}${window.location.search}`;
    const lowerPath = window.location.pathname.toLowerCase();
    const isLoginPage = lowerPath.includes('/identity/account/login') || lowerPath.includes('/account/login');

    if (isLoginPage) {
        window.location.reload();
        return;
    }

    try {
        const loginUrl = new URL('/Identity/Account/Login', window.location.origin);
        loginUrl.searchParams.set('returnUrl', currentPathAndQuery);
        loginUrl.searchParams.set('sessionExpired', '1');
        window.location.assign(loginUrl.toString());
    } catch (e) {
        window.location.reload();
    }
}

$(document).ajaxComplete(function (event, jqXHR) {
    if (isLoginResponse(jqXHR)) {
        redirectToLoginViaReload();
    }
});


//loading partial views
{
    document.querySelectorAll('.partial_view').forEach(function (o) {
        var url = o.getAttribute('data-url');

        $.get(url).done(function (data, textStatus, jqXHR) {
            if (isLoginResponse(jqXHR)) {
                redirectToLoginViaReload();
                return;
            }

            o.innerHTML = data;
        }).fail(function (jqXHR) {
            if (isLoginResponse(jqXHR)) {
                redirectToLoginViaReload();
            }
        });
    });
}

// modal operations (load / reload)
var placeholderElement = $('#modal-placeholder');

// Renders a banner outside .modal-body so it survives body replacement and keeps user input intact.
function showModalSubmitError(message) {
    var modalContent = placeholderElement.find('.modal-content').first();
    if (!modalContent.length) {
        return;
    }

    var container = modalContent.find('.modal-submit-error').first();
    if (!container.length) {
        container = $('<div class="modal-submit-error px-3 pt-3"></div>');

        var modalBody = modalContent.find('.modal-body').first();
        if (modalBody.length) {
            modalBody.before(container);
        } else {
            modalContent.prepend(container);
        }
    }

    var alertElement = $('<div class="alert alert-danger alert-dismissible fade show mb-0" role="alert"></div>')
        .append($('<span></span>').text(message))
        .append('<button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>');

    container.empty().append(alertElement);

    if (container[0] && typeof container[0].scrollIntoView === 'function') {
        container[0].scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    }
}

function clearModalSubmitError() {
    placeholderElement.find('.modal-submit-error').remove();
}

function isModalBusy() {
    return placeholderElement.find('.modal-content').first().attr('aria-busy') === 'true';
}

function setModalBusy(isBusy) {
    var modalContent = placeholderElement.find('.modal-content').first();
    if (!modalContent.length) {
        return;
    }

    var saveButtons = placeholderElement.find('[data-save="modal"]');

    if (!isBusy) {
        modalContent.removeAttr('aria-busy');
        modalContent.find('.modal-busy-overlay').remove();
        saveButtons.prop('disabled', false);
        return;
    }

    saveButtons.prop('disabled', true);
    modalContent.attr('aria-busy', 'true');

    if (modalContent.find('.modal-busy-overlay').length) {
        return;
    }

    var overlay = $('<div class="modal-busy-overlay"><div class="spinner-border text-primary" role="status"></div></div>');
    modalContent.append(overlay);

    window.requestAnimationFrame(function () {
        overlay.addClass('is-visible');
    });
}

// Keeps the dialog from collapsing while the replaced body re-initializes its widgets.
function freezeModalBodyHeight() {
    var modalBody = placeholderElement.find('.modal-body').first();
    return modalBody.length ? modalBody.outerHeight() : null;
}

function releaseModalBodyHeight(modalBody) {
    window.setTimeout(function () {
        if (modalBody && modalBody.length) {
            modalBody.css('min-height', '');
        }

        setModalBusy(false);
    }, 250);
}

if (placeholderElement.length > 0) {
    var modal_placeholder = document.getElementById('modal-placeholder');

    function restorePendingModalSubmissionIfNeeded() {
        if (window.location.pathname.toLowerCase().includes('/identity/account/login')) {
            return;
        }

        const pendingSubmission = readPendingModalSubmission();
        if (!pendingSubmission) {
            return;
        }

        const currentPageUrl = `${window.location.pathname}${window.location.search}`;
        if (pendingSubmission.pageUrl !== currentPageUrl) {
            clearPendingModalSubmission();
            return;
        }

        let c_lang = common_lang_file();
        const recoverTitle = (c_lang && c_lang["sessionExpiredResumeTitle"]) ? c_lang["sessionExpiredResumeTitle"] : "Session restored";
        const recoverText = (c_lang && c_lang["sessionExpiredResumeText"]) ? c_lang["sessionExpiredResumeText"] : "Your last unsaved changes can be submitted now. Continue?";
        const recoverBtn = (c_lang && c_lang["sessionExpiredResumeConfirm"]) ? c_lang["sessionExpiredResumeConfirm"] : "Restore and save";
        const discardBtn = (c_lang && c_lang["sessionExpiredResumeCancel"]) ? c_lang["sessionExpiredResumeCancel"] : "Discard";

        Swal.fire({
            icon: 'question',
            title: recoverTitle,
            text: recoverText,
            showCancelButton: true,
            confirmButtonText: recoverBtn,
            cancelButtonText: discardBtn
        }).then((result) => {
            if (!result.isConfirmed) {
                clearPendingModalSubmission();
                return;
            }

            // Clear immediately to avoid showing the same restore prompt again on manual page refresh.
            // If auth expires again during replay, redirectToLoginViaReload will store it back.
            clearPendingModalSubmission();
            replayPendingModalSubmission(pendingSubmission);
        });
    }

    function replayPendingModalSubmission(pendingSubmission) {
        const executeReplaySubmit = (payload) => {
            $.ajax({
                type: 'POST',
                url: pendingSubmission.actionUrl,
                data: payload
            }).done((data, textStatus, jqXHR) => {
                if (isLoginResponse(jqXHR)) {
                    redirectToLoginViaReload({ pendingModalSubmission: pendingSubmission });
                    return;
                }

                const newBody = $('.modal-body', data);
                if (newBody.length > 0) {
                    const isValid = newBody.find('[name="IsValid"]').val() == 'True';

                    if (isValid) {
                        clearPendingModalSubmission();
                        window.location.reload();
                        return;
                    }

                    clearPendingModalSubmission();
                    placeholderElement.html(data);
                    var replayScriptsToReload = placeholderElement.find('.script_to_reload');
                    fn_scripts_reload(replayScriptsToReload);
                    var myModal = new bootstrap.Modal(placeholderElement.find('.modal'), {
                        keyboard: true
                    });
                    myModal.show();
                    placeholderElement.trigger('reload.modal');
                    window.initSelect2(placeholderElement);
                    runModalPageInitializers();
                    return;
                }

                clearPendingModalSubmission();
                window.location.reload();
            }).fail((jqXHR) => {
                if (isLoginResponse(jqXHR)) {
                    redirectToLoginViaReload({ pendingModalSubmission: pendingSubmission });
                }
            });
        };

        $.get(pendingSubmission.actionUrl).done((data, textStatus, jqXHR) => {
            if (isLoginResponse(jqXHR)) {
                redirectToLoginViaReload({ pendingModalSubmission: pendingSubmission });
                return;
            }

            const wrapper = $('<div>').append($.parseHTML(data));
            const freshToken = wrapper.find('input[name="__RequestVerificationToken"]').first().val();

            if (!freshToken) {
                executeReplaySubmit(pendingSubmission.dataToSend);
                return;
            }

            const params = new URLSearchParams(pendingSubmission.dataToSend);
            params.set('__RequestVerificationToken', freshToken);
            executeReplaySubmit(params.toString());
        }).fail((jqXHR) => {
            if (isLoginResponse(jqXHR)) {
                redirectToLoginViaReload({ pendingModalSubmission: pendingSubmission });
                return;
            }

            executeReplaySubmit(pendingSubmission.dataToSend);
        });
    }

    window.fn_scripts_reload = fn_scripts_reload;
    window.runModalPageInitializers = runModalPageInitializers;

    window.fn_open_ajax_modal = function (url) {
        if (!url) return;
        var placeholder = $('#modal-placeholder').length ? $('#modal-placeholder') : $('#edit_modal');
        if (!placeholder.length) return;

        // Dispose and clean up any existing modal instance before creating a new one
        var existingModal = placeholder.find('.modal');
        if (existingModal.length && typeof bootstrap !== 'undefined' && bootstrap.Modal) {
            var existingInst = bootstrap.Modal.getInstance(existingModal[0]);
            if (existingInst) {
                existingInst.dispose();
            }
        }
        placeholder.empty();
        $('.modal-backdrop').remove();
        $('body').removeClass('modal-open').css({ overflow: '', paddingRight: '' });

        $.get(url).done(function (data, textStatus, jqXHR) {
            if (isLoginResponse(jqXHR)) {
                redirectToLoginViaReload();
                return;
            }

            placeholder.html(data);
            var scriptsToReload = placeholder.find('.script_to_reload');
            fn_scripts_reload(scriptsToReload);

            var modalEl = placeholder.find(".modal");
            if (modalEl.length && typeof bootstrap !== 'undefined' && bootstrap.Modal) {
                var myModal = bootstrap.Modal.getOrCreateInstance(modalEl[0], {
                    keyboard: true
                });
                myModal.show();
                window.initSelect2(placeholder);
                runModalPageInitializers();
                if (typeof window.fn_apply_global_tooltips === 'function') {
                    window.fn_apply_global_tooltips();
                }
            }
        }).fail(function (jqXHR) {
            if (isLoginResponse(jqXHR)) {
                redirectToLoginViaReload();
            }
        });
    };

    // Global safeguard: Prevent multiple floating action buttons on dynamic AJAX updates
    $(document).on('ajaxComplete', function () {
        var hotEls = document.querySelectorAll('.hot-actions-container');
        if (hotEls.length > 1) {
            for (var i = 1; i < hotEls.length; i++) {
                hotEls[i].remove();
            }
        }
    });

    $(document).off('click.ms_ajax_modal', '[data-toggle="ajax-modal"]').on('click.ms_ajax_modal', '[data-toggle="ajax-modal"]', function (event) {
        event.preventDefault();
        event.stopPropagation();
        if (document.body.classList.contains('is-dragging-tag')) {
            return;
        }
        var hotBtn = document.getElementById('dropdown_offset');
        if (hotBtn && typeof bootstrap !== 'undefined' && bootstrap.Dropdown) {
            var inst = bootstrap.Dropdown.getInstance(hotBtn);
            if (inst) {
                inst.hide();
            }
        }
        var url = $(this).data('url');
        window.fn_open_ajax_modal(url);
    });

    $(document).off('click.ms_ajax_modal_reload', '[data-toggle="ajax-modal-reload"]').on('click.ms_ajax_modal_reload', '[data-toggle="ajax-modal-reload"]', function (event) {
        event.preventDefault();
        event.stopPropagation();
        var url = $(this).data('url');
        if (!url) return;

        var targetSelector = $(this).data('target');
        var placeholder = (targetSelector && $(targetSelector).length)
            ? $(targetSelector)
            : ($('#modal-placeholder').length ? $('#modal-placeholder') : placeholderElement);

        $.get(url).done(function (data, textStatus, jqXHR) {
            if (isLoginResponse(jqXHR)) {
                redirectToLoginViaReload();
                return;
            }

            var $parsed = $('<div>').append($.parseHTML(data, document, true));
            var newDialog = $parsed.find('.modal-dialog');
            if (newDialog.length) {
                var currentDialog = placeholder.find('.modal-dialog');
                if (currentDialog.length) {
                    currentDialog.attr('class', newDialog.attr('class'));
                }
            }

            var newBody = $parsed.find('.modal-content');
            if (newBody.length) {
                placeholder.find('.modal-content').replaceWith(newBody);
            }
            setModalBusy(false);

            var scripts_to_reload = $parsed.filter('.script_to_reload').add($parsed.find('.script_to_reload'));
            if (!scripts_to_reload.length) {
                scripts_to_reload = placeholder.find('.script_to_reload');
            }
            fn_scripts_reload(scripts_to_reload);

            placeholder.trigger("reload.modal");
            try {
                window.initSelect2(placeholder);
            } catch (e) {
                console.error('initSelect2 error', e);
            }
            try {
                runModalPageInitializers();
            } catch (e) {
                console.error('runModalPageInitializers error', e);
            }
            if (typeof window.fn_apply_global_tooltips === 'function') {
                try {
                    window.fn_apply_global_tooltips();
                } catch (e) {
                    console.error('fn_apply_global_tooltips error', e);
                }
            }
        }).fail(function (jqXHR) {
            if (isLoginResponse(jqXHR)) {
                redirectToLoginViaReload();
            }
        });
    });

    // Global Delegated Icon Picker Handlers
    $(document).on('click', '.ms-icon-tile, .category-icon-tile', function (e) {
        e.preventDefault();
        var iconClass = $(this).data('icon-class') || $(this).data('icon');
        if (!iconClass) return;

        var $modal = $(this).closest('.modal, form, #modal-placeholder');
        $modal.find('#category_icon_input').val(iconClass);
        $modal.find('#selected_icon_preview').attr('class', iconClass + ' text-primary');

        $modal.find('.ms-icon-tile, .category-icon-tile').removeClass('is-selected active border-primary bg-soft-primary text-primary');
        $(this).addClass('is-selected');
    });

    $(document).on('click', '.ms-icon-cat-btn', function (e) {
        e.preventDefault();
        var $container = $(this).closest('.ms-icon-picker-container, .category-icon-picker');
        $container.find('.ms-icon-cat-btn').removeClass('active btn-primary').addClass('btn-outline-secondary');
        $(this).addClass('active btn-primary').removeClass('btn-outline-secondary');
        $container.find('#category_icon_filter').trigger('input');
    });

    $(document).on('input keyup', '#category_icon_filter', function () {
        var query = ($(this).val() || '').trim().toLowerCase();
        var $container = $(this).closest('.ms-icon-picker-container, .category-icon-picker');
        var activeCategory = $container.find('.ms-icon-cat-btn.active').data('category') || 'all';

        $container.find('.ms-icon-group').each(function () {
            var groupCat = $(this).data('category');
            var groupMatchesCategory = activeCategory === 'all' || groupCat === activeCategory;
            var hasVisibleIcons = false;

            $(this).find('.ms-icon-tile').each(function () {
                var icon = ($(this).data('icon-class') || $(this).data('icon') || '').toLowerCase();
                var matchesQuery = !query || icon.includes(query);
                if (groupMatchesCategory && matchesQuery) {
                    $(this).removeClass('d-none');
                    hasVisibleIcons = true;
                } else {
                    $(this).addClass('d-none');
                }
            });

            if (hasVisibleIcons) {
                $(this).removeClass('d-none');
            } else {
                $(this).addClass('d-none');
            }
        });
    });

    placeholderElement.on('click', '[data-save="modal"]', async function (event) {
        if (event) {
            event.preventDefault();
        }

        if (isModalBusy()) {
            return;
        }

        var form = $(this).closest("form");

        if (form.length == 0) {
            form = $(this).parents('.modal').find('form');
        }

        clearModalSubmitError();

        const lang_file = common_lang_file() || {};

        // Validate all native HTML5 constraints, show localized inline errors, no browser bubble.
        const applyLocalizedFormValidation = () => {
            const msgs = {
                valueMissing:    lang_file.fieldRequired    || 'This field is required.',
                patternMismatch: lang_file.invalidNumberFormat || 'Please enter a valid value.',
                typeMismatch:    lang_file.invalidInput     || 'Please enter a valid value.',
                badInput:        lang_file.invalidInput     || 'Please enter a valid value.',
                rangeUnderflow:  lang_file.valueTooSmall    || 'Value is too small.',
                rangeOverflow:   lang_file.valueTooLarge    || 'Value is too large.',
            };
            let hasError = false;
            form.find('input, select, textarea').each(function () {
                if (typeof this.setCustomValidity !== 'function') return;

                // Skip disabled inputs or inputs located inside hidden/collapsed containers
                if (this.disabled) return;
                if ($(this).closest('.d-none, [style*="display: none"], .collapse:not(.show)').length > 0) return;
                if (!$(this).is(':visible') && !$(this).hasClass('select2-hidden-accessible')) return;

                // Don't clear custom validity on fields already marked invalid by
                // validateTransactionSpecificFields — clearing would make them :valid in CSS and
                // Bootstrap's was-validated class would override is-invalid with green styling.
                if (!$(this).hasClass('is-invalid')) {
                    this.setCustomValidity('');
                }
                let v = null;
                try {
                    v = this.validity;
                } catch (validationError) {
                    // Skip fields with malformed native constraints to avoid breaking modal save flow.
                    return;
                }
                if (!v || v.valid) return;
                for (const [key, msg] of Object.entries(msgs)) {
                    if (v[key]) {
                        let finalMsg = msg;

                        // Name fields use a specific pattern error message
                        if (key === 'patternMismatch' && $(this).is('[data-val-name-pattern]')) {
                            finalMsg = lang_file.invalidNameCharacters || 'Name contains invalid characters.';
                        } else if (key === 'rangeOverflow' && $(this).is('input[type="date"]')) {
                            finalMsg = lang_file.dateCannotBeInFuture || 'Please choose today or an earlier date.';
                        }

                        this.setCustomValidity(finalMsg);
                        $(this).addClass('is-invalid').removeClass('is-valid');
                        const fieldName = this.name || this.id;
                        if (fieldName) {
                            form.find(`[data-valmsg-for="${fieldName}"]`).text(finalMsg);
                        }
                        hasError = true;
                        break;
                    }
                }
            });
            return !hasError;
        };

        const setFieldValidationMessage = (fieldName, message) => {
            if (!form || !fieldName) {
                return;
            }

            const messageElement = form.find(`[data-valmsg-for="${fieldName}"]`).first();
            if (messageElement.length > 0) {
                messageElement.text(message || '');
            }
        };

        const clearFieldValidationMessage = (fieldName) => {
            setFieldValidationMessage(fieldName, '');
        };

        const setCustomFieldValidity = (fieldName, message) => {
            const fieldElement = form.find(`[name="${fieldName}"]`).first().get(0);
            if (fieldElement && typeof fieldElement.setCustomValidity === 'function') {
                fieldElement.setCustomValidity(message || '');
            }
        };

        const validateTransactionSpecificFields = () => {
            let isValid = true;

            const hasTransactionModal = form.find('#transactionItemsTable').length > 0;
            if (!hasTransactionModal) {
                return isValid;
            }

            let transactionItemsCount = 0;

            if (window.transactionItemsTableInstance && typeof window.transactionItemsTableInstance.getData === 'function') {
                const transactionItems = window.transactionItemsTableInstance.getData() || [];
                transactionItemsCount = transactionItems.length;
            } else {
                const transactionItemsTable = form.find('#transactionItemsTable');
                const rawData = transactionItemsTable.attr('data-items');
                if (rawData) {
                    try {
                        const parsedData = JSON.parse(rawData);
                        transactionItemsCount = Array.isArray(parsedData) ? parsedData.length : 0;
                    } catch (e) {
                        transactionItemsCount = 0;
                    }
                }
            }

            const transactionItemsMessage = transactionItemsCount <= 0
                ? (lang_file.atLeastOneTagRequired || 'At least one tag is required.')
                : '';

            setFieldValidationMessage('TransactionItems', transactionItemsMessage);
            setCustomFieldValidity('TransactionItems', transactionItemsMessage);

            if (transactionItemsMessage) {
                isValid = false;
            }

            const isTransferRaw = String(form.find('input[name="IsTransfer"]').val() || '').toLowerCase();
            const isTransfer = isTransferRaw === 'true';
            if (!isTransfer) {
                clearFieldValidationMessage('InvolvedAccountId');
                setCustomFieldValidity('InvolvedAccountId', '');
                return isValid;
            }

            const sourceAccountId = Number(form.find('select[name="AccountId"]').val() || 0);
            const involvedAccountId = Number(form.find('select[name="InvolvedAccountId"]').val() || 0);
            const involvedAccountMessage = sourceAccountId > 0 && involvedAccountId > 0 && sourceAccountId === involvedAccountId
                ? (lang_file.transferAccountsMustDiffer || 'Transfer source and destination accounts must be different.')
                : '';

            setFieldValidationMessage('InvolvedAccountId', involvedAccountMessage);
            setCustomFieldValidity('InvolvedAccountId', involvedAccountMessage);

            const sourceSelect = form.find('select[name="AccountId"]').first();
            const involvedSelect = form.find('select[name="InvolvedAccountId"]').first();
            if (involvedAccountMessage) {
                sourceSelect.removeClass('is-valid').addClass('is-invalid');
                involvedSelect.removeClass('is-valid').addClass('is-invalid');
                isValid = false;
            } else {
                sourceSelect.removeClass('is-invalid');
                involvedSelect.removeClass('is-invalid');
            }

            return isValid;
        };

        const confirmCloseActionIfNeeded = async () => {
            const closeToggle = form.find('[data-confirm-close-target="period"]').first();
            if (!closeToggle.length) {
                return true;
            }

            const initialChecked = String(closeToggle.data('initialChecked')).toLowerCase() === 'true';
            const currentChecked = closeToggle.is(':checked');

            if (!currentChecked || initialChecked === currentChecked) {
                return true;
            }

            const confirmationResult = await Swal.fire({
                icon: 'warning',
                title: lang_file.closePeriodConfirmTitle || 'Close period?',
                text: lang_file.closePeriodConfirmText || 'This period will be marked as closed. Continue?',
                showCancelButton: true,
                confirmButtonText: lang_file.closePeriodConfirmButton || 'Yes, close period',
                cancelButtonText: lang_file.closePeriodCancelButton || 'Cancel',
                confirmButtonColor: '#f1b44c',
                cancelButtonColor: '#74788d'
            });

            return confirmationResult.isConfirmed;
        };

        const transactionSpecificFieldsValid = validateTransactionSpecificFields();

        // Localize all native HTML5 validation errors inline (no browser bubble).
        const nativeFieldsValid = applyLocalizedFormValidation();

        if (!nativeFieldsValid) {
            form.addClass('was-validated');
            return;
        }

        const parsleyForm = $(form).parsley({
            excluded: 'input[type=button], input[type=submit], input[type=reset], input[type=hidden], :hidden, [disabled]'
        });
        const isParsleyValid = parsleyForm.validate();

        if (transactionSpecificFieldsValid && isParsleyValid) {
            const closeActionConfirmed = await confirmCloseActionIfNeeded();
            if (!closeActionConfirmed) {
                return;
            }

            var actionUrl = $(this).attr('formaction');
            // attribute exists?
            if (!(typeof actionUrl !== 'undefined' && actionUrl !== false)) {
                actionUrl = form.attr('action');
            }

            var dataToSend = serializeFormRespectingInputmask(form);

            // Add Tabulator transaction items data if it exists
            if (window.transactionItemsTableInstance) {
                const tableData = window.transactionItemsTableInstance.getData();
                // Filter out the _isNew flag and only include non-empty values
                const cleanedData = tableData.map(item => ({
                    Tag: item.tag,
                    Quantity: item.quantity,
                    Price: item.price
                }));

                // Serialize the transaction items as indexed array for model binding
                cleanedData.forEach((item, index) => {
                    dataToSend += `&TransactionItems[${index}].Tag=${encodeURIComponent(item.Tag)}`;
                    // Only include quantity and price if they have values
                    if (item.Quantity !== null && item.Quantity !== undefined && item.Quantity !== '') {
                        dataToSend += `&TransactionItems[${index}].Quantity=${item.Quantity}`;
                    }
                    if (item.Price !== null && item.Price !== undefined && item.Price !== '') {
                        dataToSend += `&TransactionItems[${index}].Price=${item.Price}`;
                    }
                });
            }

            const pendingSubmission = buildPendingModalSubmission(actionUrl, dataToSend);

            setModalBusy(true);

            $.ajax({
                type: "POST",
                url: actionUrl,
                data: dataToSend,
                // processData: true,
                // dataType: 'json'
                // context: document.body
            }).done((data, textStatus, jqXHR) => {
                if (isLoginResponse(jqXHR)) {
                    redirectToLoginViaReload({ pendingModalSubmission: pendingSubmission });
                    return;
                }

                var newBody = $('.modal-body', data);

                // Some actions (for example delete) can return a redirect/full page instead of modal partial.
                // In that case, treat the request as successful and continue with normal refresh + close flow.
                if (!newBody.length) {
                    clearPendingModalSubmission();

                    var fullPageModal = bootstrap.Modal.getInstance(placeholderElement.find('.modal'));
                    if (fullPageModal) {
                        const focusedElement = placeholderElement.find('.modal')[0]?.querySelector(':focus');
                        if (focusedElement) {
                            focusedElement.blur();
                        }
                        fullPageModal.hide();
                    }

                    setModalBusy(false);
                    window.location.reload();
                    return;
                }

                // console.log('post request sent');
                const previousBodyHeight = freezeModalBodyHeight();

                placeholderElement.find('.modal-body').replaceWith(newBody);

                var newFooter = $('.modal-footer', data);
                if (newFooter.length) {
                    placeholderElement.find('.modal-footer').replaceWith(newFooter);
                }

                if (previousBodyHeight) {
                    newBody.css('min-height', previousBodyHeight + 'px');
                }

                try {
                    window.initSelect2(placeholderElement);
                } catch (e) {
                    console.error('initSelect2 error', e);
                }
                try {
                    runModalPageInitializers();
                } catch (e) {
                    console.error('runModalPageInitializers error', e);
                }

                // find IsValid input field and check it's value
                // if it's valid then hide modal window
                var isValid = newBody.find('[name="IsValid"]').val() == 'True';

                if (isValid) {
                    clearPendingModalSubmission();

                    if (form.data('refresh-page-on-save') === true) {
                        window.location.reload();
                        return;
                    }

                    var tableElement = $('#refreshable-content');
                    if (tableElement.length) {
                        var tableUrl = tableElement.data('url');

                        var page_number = tableElement.attr('page_number');

                        // attribute exists?
                        if (page_number) {
                            var url = new URL(window.location.origin + tableUrl);
                            url.searchParams.set('page_number', page_number);
                            tableUrl = url.toString().replace(window.location.origin, "");
                        }

                        // refreshing of all refreshable content
                        $.get(tableUrl).done(function (table, textStatus, jqXHR) {
                            if (isLoginResponse(jqXHR)) {
                                redirectToLoginViaReload();
                                return;
                            }

                            tableElement.replaceWith(table);
                            $('#top_preloader .status').hide();
                            $('#top_preloader').hide();
                            $('#table_preloader .status').hide();
                            $('#table_preloader').hide();
                            $(document).trigger('ajax_modal_success');
                            // page bundles import their own jQuery and do not see the event above
                            document.dispatchEvent(new CustomEvent('ajax_modal_success'));
                        }).fail(function (jqXHR) {
                            if (isLoginResponse(jqXHR)) {
                                redirectToLoginViaReload();
                            }
                        });
                    }

                    // refresh budget widget on transactions page after successful modal save
                    const budgetWidgetEl = document.getElementById('transaction-budget-widget');
                    if (budgetWidgetEl) {
                        const budgetUrl = budgetWidgetEl.dataset.url;
                        if (budgetUrl) {
                            $.get(budgetUrl).done(function(html, _status, budgetJqXHR) {
                                if (!isLoginResponse(budgetJqXHR)) {
                                    $('#transaction-budget-widget').replaceWith(html);
                                }
                            });
                        }
                    }

                    // getting existing created bootstrap modal object
                    var modalEl = placeholderElement.find(".modal");
                    var myModal = modalEl.length && typeof bootstrap !== 'undefined' && bootstrap.Modal
                        ? bootstrap.Modal.getInstance(modalEl[0])
                        : null;

                    // Remove focus from any focused element inside modal before hiding to prevent aria-hidden conflict
                    if (modalEl.length) {
                        const focusedElement = modalEl[0].querySelector(':focus');
                        if (focusedElement) {
                            focusedElement.blur();
                        }
                    }

                    if (myModal) {
                        myModal.hide();
                    }

                    setModalBusy(false);

                    let c_lang = common_lang_file();
                    let successMsg = (c_lang && c_lang["saveSuccess"]) ? c_lang["saveSuccess"] : "Successfully saved!";
                    Swal.fire({
                        position: 'bottom-end',
                        icon: 'success',
                        title: successMsg,
                        showConfirmButton: false,
                        timer: 2000,
                        toast: true
                    });
                }
                else {
                    setModalBusy(false);
                    placeholderElement.trigger("reload.modal");
                    releaseModalBodyHeight(newBody);
                }
            }).fail(function (jqXHR, textStatus, errorThrown) {
                setModalBusy(false);

                if (isLoginResponse(jqXHR)) {
                    redirectToLoginViaReload({ pendingModalSubmission: pendingSubmission });
                    return;
                }

                console.error('Error saving transaction:', textStatus, errorThrown);

                // Keep the modal untouched: re-initializing it here duplicated tag handlers and lost user input.
                let f_lang = common_lang_file();
                let errorMsg = (f_lang && f_lang["unexpectedErrorTryAgain"])
                    ? f_lang["unexpectedErrorTryAgain"]
                    : "Something went wrong. Please try again — we are already working on a fix.";

                showModalSubmitError(errorMsg);
            });
        }
    });

    // transaction upsert method handling, is called when modal window is shown
    // modal_placeholder.addEventListener('show.bs.modal', function (event) {

    placeholderElement.on("reload.modal", fn_transactions_upsert_modal_initialization);
    modal_placeholder.addEventListener('show.bs.modal', fn_transactions_upsert_modal_initialization);

    modal_placeholder.addEventListener('hidden.bs.modal', function (event) {
        setModalBusy(false);
        clearModalSubmitError();
        const modalEl = event.target;
        if (modalEl && typeof bootstrap !== 'undefined' && bootstrap.Modal) {
            const inst = bootstrap.Modal.getInstance(modalEl);
            if (inst) {
                inst.dispose();
            }
        }
        placeholderElement.empty();
        $('.modal-backdrop').remove();
        $('body').removeClass('modal-open').css({ overflow: '', paddingRight: '' });
    });

    var partial_placeholder = document.getElementById('partial-placeholder');
    if (partial_placeholder) {
        fn_transactions_upsert_modal_initialization();
    }

    function fn_transactions_upsert_modal_initialization(event) {
        placeholderElement.find('.focused_element').focus();

        const bindTransferAccountsRealtimeValidation = () => {
            const transactionForm = placeholderElement.find('.modal form').first();
            if (!transactionForm.length) {
                return;
            }

            const localLang = common_lang_file() || {};

            const applyTransferAccountValidationState = (message) => {
                const validationMessage = message || '';
                const messageElement = transactionForm.find('[data-valmsg-for="InvolvedAccountId"]').first();
                const involvedSelect = transactionForm.find('select[name="InvolvedAccountId"]').first();
                const sourceSelect = transactionForm.find('select[name="AccountId"]').first();
                const involvedField = involvedSelect.get(0);

                if (messageElement.length) {
                    messageElement.text(validationMessage);
                }

                if (involvedField && typeof involvedField.setCustomValidity === 'function') {
                    involvedField.setCustomValidity(validationMessage);
                }

                if (!validationMessage) {
                    involvedSelect.removeClass('input-validation-error is-invalid');
                    sourceSelect.removeClass('is-invalid');
                } else {
                    involvedSelect.removeClass('is-valid').addClass('is-invalid');
                    sourceSelect.removeClass('is-valid').addClass('is-invalid');
                }
            };

            const validateTransferAccountsRealtime = () => {
                const isTransferRaw = String(transactionForm.find('input[name="IsTransfer"]').val() || '').toLowerCase();
                const isTransfer = isTransferRaw === 'true';

                if (!isTransfer) {
                    applyTransferAccountValidationState('');
                    return;
                }

                const sourceAccountId = Number(transactionForm.find('select[name="AccountId"]').val() || 0);
                const involvedAccountId = Number(transactionForm.find('select[name="InvolvedAccountId"]').val() || 0);

                const message = sourceAccountId > 0 && involvedAccountId > 0 && sourceAccountId === involvedAccountId
                    ? (localLang.transferAccountsMustDiffer || 'Transfer source and destination accounts must be different.')
                    : '';

                applyTransferAccountValidationState(message);
            };

            placeholderElement.off('change.ms-transfer-validation', '.modal select[name="AccountId"], .modal select[name="InvolvedAccountId"]');
            placeholderElement.on('change.ms-transfer-validation', '.modal select[name="AccountId"], .modal select[name="InvolvedAccountId"]', validateTransferAccountsRealtime);

            validateTransferAccountsRealtime();
        };

        bindTransferAccountsRealtimeValidation();

        const bindTransactionDateRealtimeValidation = () => {
            const transactionForm = placeholderElement.find('.modal form').first();
            if (!transactionForm.length) {
                return;
            }

            if (!transactionForm.find('input[name="TransactionDate"]').length) {
                return;
            }

            const localLang = common_lang_file() || {};

            const validateTransactionDateRealtime = function () {
                const dateInput = $(this);
                const dateField = dateInput.get(0);
                const messageElement = transactionForm.find('[data-valmsg-for="TransactionDate"]').first();

                // Editing the date always drops the message rendered for the previous value.
                messageElement.text('');
                dateInput.removeClass('input-validation-error is-invalid');

                if (dateField && typeof dateField.setCustomValidity === 'function') {
                    dateField.setCustomValidity('');
                }

                const selectedDate = dateInput.val();
                if (!selectedDate) {
                    return;
                }

                const now = new Date();
                const localToday = new Date(now.getTime() - now.getTimezoneOffset() * 60000)
                    .toISOString()
                    .slice(0, 10);

                if (selectedDate <= localToday) {
                    return;
                }

                const message = localLang.dateCannotBeInFuture
                    || 'Transactions cannot be created for a future date. Please choose today or an earlier date.';

                messageElement.text(message);
                dateInput.removeClass('is-valid').addClass('is-invalid');

                if (dateField && typeof dateField.setCustomValidity === 'function') {
                    dateField.setCustomValidity(message);
                }
            };

            placeholderElement.off('change.ms-date-validation input.ms-date-validation', '.modal input[name="TransactionDate"]');
            placeholderElement.on('change.ms-date-validation input.ms-date-validation', '.modal input[name="TransactionDate"]', validateTransactionDateRealtime);
        };

        bindTransactionDateRealtimeValidation();

        // Set localized Parsley messages for pattern/required fields on this modal.
        (() => {
            const transactionForm = placeholderElement.find('.modal form').first();
            if (!transactionForm.length) return;
            const localLang = common_lang_file() || {};
            const numberPatternMsg = localLang.invalidNumberFormat  || 'Please enter a valid number.';
            const namePatternMsg   = localLang.invalidNameCharacters || 'Name contains invalid characters.';
            const requiredMsg      = localLang.fieldRequired         || 'This field is required.';
            transactionForm.find('input[pattern][data-val-name-pattern], textarea[pattern][data-val-name-pattern]').each(function () {
                $(this).attr('data-parsley-pattern-message', namePatternMsg);
            });
            transactionForm.find('input[pattern]:not([data-val-name-pattern]), textarea[pattern]:not([data-val-name-pattern])').each(function () {
                $(this).attr('data-parsley-pattern-message', numberPatternMsg);
            });
            transactionForm.find('[required]').each(function () {
                if (!$(this).attr('data-parsley-required-message')) {
                    $(this).attr('data-parsley-required-message', requiredMsg);
                }
            });
        })();

        try {
            var value_from = document.getElementById('InvolvedTransactionAmount');
            if (value_from) {
                var value_to = document.getElementById('TransactionAmount');
                var currency_rate = document.getElementById('CurrencyRate');

                value_from.addEventListener('keyup', fn_process_to_value);
                currency_rate.addEventListener('keyup', fn_process_to_value);



                function fn_process_to_value(e) {
                    var v_from = 0;
                    if (typeof value_from.value === 'string') {
                        v_from = value_from.value.replace(',', '.');
                    } else {
                        v_from = value_from.value;
                    }

                    // console.log(`value_from.value: ${value_from.value} >>> v_from: ${v_from}`);

                    var v_curr_rate = 0;
                    if (typeof currency_rate.value === 'string') {
                        v_curr_rate = currency_rate.value.replace(',', '.');
                    } else {
                        v_curr_rate = currency_rate.value;
                    }

                    // console.log(`currency_rate.value: ${currency_rate.value} >>> v_curr_rate: ${v_curr_rate}`);
                    // Parse values to numbers to ensure valid calculation
                    var numFrom = parseFloat(v_from);
                    var numRate = parseFloat(v_curr_rate);
                    
                    // Only update if both values are valid numbers, otherwise keep previous value
                    if (Number.isFinite(numFrom) && Number.isFinite(numRate)) {
                        value_to.value = `${(numFrom * numRate).toFixed(2)}`;
                    }

                    // Removed duplicate calculation of value_to
                }
            }
        } catch (e) {
            if (e instanceof TypeError) {
                printError(e, true);
            } else {
                printError(e, false);
            }

            console.error(e.name);    // logs 'Error'
            console.error(e.message); // logs 'The message', or a JavaScript error message
        };


        const clearTransactionItemsValidationState = () => {
            const transactionForm = placeholderElement.find('.modal form').first();
            if (!transactionForm.length) {
                return;
            }

            transactionForm.find('[data-valmsg-for="TransactionItems"]').first().text('');
            transactionForm.find('#TransactionItems').removeClass('input-validation-error is-invalid');
        };

        try {
            let lang_file = common_lang_file();

            // if element Tags exists, load the data
            var tags_element = placeholderElement.find('.modal #TransactionItems');

            if (tags_element.length > 0 && tags_element[0].dataset.msChoicesInitialized !== 'true') {
                tags_element[0].dataset.msChoicesInitialized = 'true';

                var choices = new Choices('#TransactionItems', {
                    delimiter: ',',
                    paste: false,
                    editItems: true,
                    addItems: true,
                    addItemFilter: () => true, // allow any new value
                    maxItemCount: -1,
                    duplicateItemsAllowed: false,
                    removeItemButton: true,
                    paste: true,
                    shouldSort: false,
                    shouldSortItems: false,
                    //placeholder: true,
                    //placeholderValue: lang_file["tagsPlaceholder"] || "Enter tags...",
                    //searchPlaceholderValue: lang_file["tagsPlaceholder"] || "Enter tags...",
                    searchResultLimit: 3,
                    renderChoiceLimit: 3,
                    searchChoices: true,
                    searchEnabled: true,
                    loadingText: lang_file["loadingText"],
                    noResultsText: lang_file["noResultsText"],
                    noChoicesText: lang_file["noChoicesText"],
                    itemSelectText: lang_file["itemSelectText"],
                    addItemText: (value) => {
                        return lang_file["addItemText"].replace("{value}", value);
                    }
                });

                // Set placeholder on the cloned input element that Choices.js creates
                // Using setTimeout to ensure DOM is fully rendered
                setTimeout(() => {
                    const choicesInner = tags_element[0].parentElement;
                    const choicesInput = choicesInner.querySelector('.choices__input--cloned');
                    if (choicesInput) {
                        choicesInput.setAttribute('placeholder', lang_file["tagsPlaceholder"] || "Enter tags...");
                        choicesInput.setAttribute('enterkeyhint', 'enter');
                        choicesInput.addEventListener('blur', function () {
                            if (this.value.trim() !== '') {
                                const e = new KeyboardEvent('keydown', { key: 'Enter', keyCode: 13, which: 13, bubbles: true });
                                choicesInput.dispatchEvent(e);
                            }
                        });
                    }
                }, 100);

                var lookup_address = "/api/on_get_select_all_lookup_asynch";

                choices.setChoices(async () => {
                    try {
                        const items = await fetch(lookup_address)
                            .then(response => response.json());
                        return items;
                    } catch (err) {
                        console.error(err);
                    }
                });

                // Listen for item added event
                tags_element[0].addEventListener('addItem', function (event) {
                    const tagValue = event.detail.value;

                    // Parse tag format: tag_name:price or tag_name:pricexquantity
                    let tag = tagValue;
                    let price; // = 0.00;
                    let quantity;// = 1;

                    if (tagValue.includes(':')) {
                        const parts = tagValue.split(':');
                        tag = parts[0];

                        // Support both Latin 'x' and Cyrillic 'х' for quantity separator
                        if (parts[1].includes('x') || parts[1].includes('х')) {
                            const priceQty = parts[1].split(/[xх]/);
                            price = parseFloat(priceQty[0]); // || 0.00;
                            quantity = parseFloat(priceQty[1]); // || 1;
                        } else {
                            price = parseFloat(parts[1]); // || 0.00;
                        }
                    }

                    // Add new row to Tabulator table if it exists with animation
                    if (window.transactionItemsTableInstance) {
                        // Add row with animation flag
                        const newRow = window.transactionItemsTableInstance.addRow({
                            tag: tag,
                            quantity: quantity,
                            price: price,
                            _isNew: true
                        }, true); // true = add at top

                        // Remove animation flag after animation completes
                        newRow.then((row) => {
                            setTimeout(() => {
                                row.update({ ...row.getData(), _isNew: false });
                            }, 600);
                        });

                        clearTransactionItemsValidationState();
                    }

                    // Remove the item from input field after adding to Tabulator table
                    setTimeout(() => {
                        choices.removeActiveItemsByValue(tagValue);
                        choices.removeChoice(tagValue);
                    }, 100);
                }, false);
            }
        }
        catch (e) {
            if (e instanceof TypeError) {
                printError(e, true);
            } else {
                printError(e, false);
            }
        };
        // Initialize Tabulator for transaction items table
        try {
            const tableElement = document.getElementById('transactionItemsTable');

            if (tableElement) {
                // Destroy existing table if it exists
                if (window.transactionItemsTableInstance) {
                    window.transactionItemsTableInstance.destroy();
                }

                // Get data from data attribute
                let data = [];
                const dataAttr = tableElement.getAttribute('data-items');
                if (dataAttr) {
                    try {
                        data = JSON.parse(dataAttr);
                    } catch (e) {
                        console.error('Error parsing data-items:', e);
                    }
                }

                let lang_file = common_lang_file();

                // Initialize Tabulator with Bootstrap 5 theme
                window.transactionItemsTableInstance = new Tabulator(tableElement, {
                    layout: "fitColumns",
                    responsiveLayout: "collapse",
                    pagination: true,
                    paginationSize: 5,
                    paginationSizeSelector: [3, 5, 10],
                    locale: (current_lang_short() || "en").toLowerCase(),
                    langs: {
                        "default": {
                            "pagination": {
                                "page_size": "Page Size",
                                "page_title": "Show Page",
                                "first": "First",
                                "first_title": "First Page",
                                "last": "Last",
                                "last_title": "Last Page",
                                "prev": "Prev",
                                "prev_title": "Prev Page",
                                "next": "Next",
                                "next_title": "Next Page",
                                "all": "All",
                                "counter": {
                                    "showing": "Showing",
                                    "of": "of",
                                    "rows": "rows",
                                    "pages": "pages"
                                }
                            }
                        },
                        "uk": {
                            "pagination": {
                                "page_size": "Розмір сторінки",
                                "page_title": "Показати сторінку",
                                "first": "Перша",
                                "first_title": "Перша сторінка",
                                "last": "Остання",
                                "last_title": "Остання сторінка",
                                "prev": "Попередня",
                                "prev_title": "Попередня сторінка",
                                "next": "Наступна",
                                "next_title": "Наступна сторінка",
                                "all": "Всі",
                                "counter": {
                                    "showing": "Показано",
                                    "of": "з",
                                    "rows": "рядків",
                                    "pages": "сторінок"
                                }
                            }
                        },
                        "pl": {
                            "pagination": {
                                "page_size": "Rozmiar strony",
                                "page_title": "Pokaż stronę",
                                "first": "Pierwsza",
                                "first_title": "Pierwsza strona",
                                "last": "Ostatnia",
                                "last_title": "Ostatnia strona",
                                "prev": "Poprzednia",
                                "prev_title": "Poprzednia strona",
                                "next": "Następna",
                                "next_title": "Następna strona",
                                "all": "Wszystkie",
                                "counter": {
                                    "showing": "Wyświetlono",
                                    "of": "z",
                                    "rows": "wierszy",
                                    "pages": "stron"
                                }
                            }
                        },
                        "de": {
                            "pagination": {
                                "page_size": "Seitengröße",
                                "page_title": "Seite anzeigen",
                                "first": "Erste",
                                "first_title": "Erste Seite",
                                "last": "Letzte",
                                "last_title": "Letzte Seite",
                                "prev": "Vorherige",
                                "prev_title": "Vorherige Seite",
                                "next": "Nächste",
                                "next_title": "Nächste Seite",
                                "all": "Alle",
                                "counter": {
                                    "showing": "Zeige",
                                    "of": "von",
                                    "rows": "Zeilen",
                                    "pages": "Seiten"
                                }
                            }
                        },
                        "es": {
                            "pagination": {
                                "page_size": "Tamaño de página",
                                "page_title": "Mostrar página",
                                "first": "Primera",
                                "first_title": "Primera página",
                                "last": "Última",
                                "last_title": "Última página",
                                "prev": "Anterior",
                                "prev_title": "Página anterior",
                                "next": "Siguiente",
                                "next_title": "Página siguiente",
                                "all": "Todo",
                                "counter": {
                                    "showing": "Mostrando",
                                    "of": "de",
                                    "rows": "filas",
                                    "pages": "páginas"
                                }
                            }
                        },
                        "it": {
                            "pagination": {
                                "page_size": "Dimensione pagina",
                                "page_title": "Mostra pagina",
                                "first": "Prima",
                                "first_title": "Prima pagina",
                                "last": "Ultima",
                                "last_title": "Ultima pagina",
                                "prev": "Precedente",
                                "prev_title": "Pagina precedente",
                                "next": "Successiva",
                                "next_title": "Pagina successiva",
                                "all": "Tutti",
                                "counter": {
                                    "showing": "Visualizzazione",
                                    "of": "di",
                                    "rows": "righe",
                                    "pages": "pagine"
                                }
                            }
                        }
                    },
                    data: data,
                    dataChanged: function (updatedData) {
                        if (Array.isArray(updatedData) && updatedData.length > 0) {
                            clearTransactionItemsValidationState();
                        }
                    },
                    rowFormatter: function (row) {
                        const data = row.getData();
                        if (data._isNew) {
                            row.getElement().style.animation = 'slideInFade 0.5s ease-out';
                            row.getElement().style.backgroundColor = '#e7f1ff';
                            setTimeout(() => {
                                row.getElement().style.backgroundColor = '';
                            }, 500);
                        }
                    },
                    columns: [
                        {
                            title: lang_file["tag"],
                            field: "tag",
                            minWidth: 120,
                            widthGrow: 4,
                            responsive: 0,
                            editor: "input",
                            validator: "required"
                        }/*, -- TEMPRORARILY DISABLED --
                        {
                            title: lang_file["qty"],
                            field: "quantity",
                            width: "50",
                            headerHozAlign: "right",
                            hozAlign: "right",
                            editor: "number",
                            editorParams: {
                                min: 1,
                                step: 1
                            },
                            validator: function(cell, value) {
                                // Allow empty values, but if provided must be >= 1
                                if (value === null || value === undefined || value === '') {
                                    return true;
                                }
                                return value >= 1;
                            },
                            sorter: "number",
                            formatter: function(cell) {
                                const value = cell.getValue();
                                return value || '';
                            }
                        }*/,
                        {
                            title: lang_file["price"],
                            field: "price",
                            minWidth: 88,
                            widthGrow: 1,
                            headerHozAlign: "right",
                            hozAlign: "right",
                            responsive: 1,
                            editor: "number",
                            editorParams: {
                                min: 0,
                                step: 0.01
                            },
                            validator: function (cell, value) {
                                // Allow empty values, but if provided must be >= 0
                                if (value === null || value === undefined || value === '') {
                                    return true;
                                }
                                return value >= 0;
                            },
                            sorter: "number",
                            formatter: function (cell) {
                                const value = cell.getValue();
                                if (value === null || value === undefined || value === '') {
                                    return '';
                                }
                                return parseFloat(value).toFixed(2);
                            }
                        },
                        {
                            title: "",
                            field: "delete",
                            width: 56,
                            hozAlign: "center",
                            headerSort: false,
                            responsive: 0,
                            formatter: function (cell) {
                                return '<button class="btn btn-sm btn-danger p-1" type="button" title="' + ((lang_file && lang_file["delete"]) ? lang_file["delete"] : 'Delete') + '"><i class="fas fa-trash-alt"></i></button>';
                            },
                            cellClick: function (e, cell) {
                                cell.getRow().delete();
                            }
                        }
                    ]
                });

                if (data.length > 0) {
                    clearTransactionItemsValidationState();
                }

                console.log('Tabulator initialized with', data.length, 'rows');
            }
        } catch (e) {
            console.error('Error initializing Tabulator:', e);
        }
        var printError = function (error, explicit) {
            console.log(`[${explicit ? 'EXPLICIT' : 'INEXPLICIT'}] ${error.name}: ${error.message}`);
        }
    };

    // allow function keys and decimal separators
    placeholderElement.on('keydown', 'input.number', function (e) {
        if (
            // backspace, delete, tab, escape, enter, comma and .
            $.inArray(e.keyCode, [46, 8, 9, 27, 13, 110, 188, 190]) !== -1 ||
            // Ctrl/cmd+A, Ctrl/cmd+C, Ctrl/cmd+X
            ($.inArray(e.keyCode, [65, 67, 88]) !== -1 && (e.ctrlKey === true || e.metaKey === true)) ||
            // home, end, left, right
            (e.keyCode >= 35 && e.keyCode <= 39)) {

            return;
        }
        // block any non-number
        if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
            e.preventDefault();
        }
    });
};

function fn_scripts_reload(reload_scripts) {
    if (!reload_scripts || !reload_scripts.length) return;
    for (var i = 0; i < reload_scripts.length; i++) {
        var rawSrc = $(reload_scripts[i]).attr("src");
        if (!rawSrc) continue;
        var cleanSrc = rawSrc.split('?')[0];
        var newSrc = cleanSrc + "?v=" + fn_random_hash();

        // Remove old scripts with the same base src from head to prevent accumulation
        $('head script').filter(function () {
            var s = $(this).attr('src');
            return s && s.split('?')[0] === cleanSrc;
        }).remove();

        var new_script = $(reload_scripts[i]).clone().removeAttr("src");
        reload_scripts[i].remove();
        new_script.on('load', function () {
            runModalPageInitializers();
        });
        new_script.attr('src', newSrc).appendTo('head');
    }
};

function fn_random_hash() {
    return Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 2)
}


{ // get transactions details by ID on ANY page
    var current_url = window.location.href;
    if (current_url.indexOf('#id') != -1 && current_url.indexOf('=') != -1) {
        var btn = document.createElement("a");   // Create a <button> element
        btn.setAttribute("data-toggle", "ajax-modal");
        var data_url = "/transaction/details/" + current_url.split('=').pop(); // take last id after =
        btn.setAttribute("data-url", data_url);

        document.body.appendChild(btn);
        btn.click();
    }
};

// Expose getter function to retrieve table data for form submission
window.getTransactionItemsData = function () {
    if (window.transactionItemsTableInstance) {
        return window.transactionItemsTableInstance.getData();
    }
    return [];
};

// Global tooltips function
window.fn_apply_global_tooltips = function () {
    $('input:not([type="hidden"]), select, textarea').each(function () {
        var $el = $(this);

        if ($el.is(':radio, :checkbox, .btn-check') || String($el.attr('data-skip-tooltip')).toLowerCase() === 'true') {
            return;
        }

        // Skip if already applied
        if ($el.attr('data-bs-toggle') === 'tooltip' || $el.data('tooltip-applied')) {
            return;
        }

        var tooltipText = $el.attr('title') || $el.attr('placeholder');
        var id = $el.attr('id');
        var $label = null;

        if (id) {
            $label = $('label[for="' + id + '"]');
        } else {
            $label = $el.closest('label');
        }

        // a tooltip must explain the field, so one that only repeats the label is not shown
        if (tooltipText && $label && $label.length && tooltipText.trim() === $label.text().trim()) {
            tooltipText = null;
        }

        if (tooltipText) {
            // Mark as applied
            $el.data('tooltip-applied', true);
            // Remove native title
            $el.removeAttr('title');

            if ($label && $label.length > 0) {
                // Welcome Wizard pattern: Add info icon to the label
                if ($label.find('.bx-info-circle, .bx-help-circle').length === 0) {
                    $label.addClass('d-flex align-items-center');
                    var $icon = $('<i class="bx bx-info-circle text-muted ms-1" data-bs-toggle="tooltip"></i>');
                    $icon.attr('title', tooltipText);
                    $label.append($icon);
                    // Init tooltip
                    if (typeof bootstrap !== 'undefined' && bootstrap.Tooltip) {
                        try {
                            bootstrap.Tooltip.getOrCreateInstance($icon[0], {
                                container: 'body',
                                popperConfig: function (defaultBsPopperConfig) {
                                    return {
                                        ...defaultBsPopperConfig,
                                        strategy: 'fixed'
                                    };
                                }
                            });
                        } catch (e) {}
                    }
                }
            } else {
                // Apply directly to element if no label
                $el.attr('data-bs-toggle', 'tooltip');
                $el.attr('data-bs-placement', 'top');
                $el.attr('title', tooltipText);
                if (typeof bootstrap !== 'undefined' && bootstrap.Tooltip) {
                    try {
                        bootstrap.Tooltip.getOrCreateInstance($el[0], {
                            container: 'body',
                            popperConfig: function (defaultBsPopperConfig) {
                                return {
                                    ...defaultBsPopperConfig,
                                    strategy: 'fixed'
                                };
                            }
                        });
                    } catch (e) {}
                }
            }
        }
    });

    // Ensure all existing uninitialized tooltips are initialized
    if (typeof bootstrap !== 'undefined' && bootstrap.Tooltip) {
        document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach(function (el) {
            try {
                bootstrap.Tooltip.getOrCreateInstance(el, {
                    container: 'body',
                    popperConfig: function (defaultBsPopperConfig) {
                        return {
                            ...defaultBsPopperConfig,
                            strategy: 'fixed'
                        };
                    }
                });
            } catch (e) {}
        });
    }
};

// Smart tag dropdown boundary alignment (horizontal end-align & vertical dropup)
$(document).on('mouseenter', '.ms-tag-dropdown', function () {
    const $container = $(this);
    const $menu = $container.find('> .dropdown-menu');
    if (!$menu.length) return;

    $menu.removeClass('dropdown-menu-end');
    $container.removeClass('dropup');

    const offset = $container.offset();
    if (!offset) return;

    const tagHeight = $container.outerHeight() || 26;
    const menuWidth = 185;
    const menuHeight = $menu.outerHeight() || 76;
    const windowWidth = $(window).width();
    const windowHeight = $(window).height();
    const scrollTop = $(window).scrollTop();

    const $boundary = $container.closest('.modal-body, .modal-content, .card-body, .ms-category-tags-collapse, body');
    const boundaryRight = $boundary.length ? $boundary.offset().left + $boundary.outerWidth() : windowWidth;
    const boundaryBottom = $boundary.length ? $boundary.offset().top + $boundary.outerHeight() : (scrollTop + windowHeight);

    // Horizontal check
    if ((offset.left + menuWidth > boundaryRight - 15) || (offset.left + menuWidth > windowWidth - 15)) {
        $menu.addClass('dropdown-menu-end');
    }

    // Vertical check: if dropdown extends below boundary bottom or window bottom, make it dropup (open upwards)
    const tagBottom = offset.top + tagHeight;
    const viewportBottom = scrollTop + windowHeight;
    if ((tagBottom + menuHeight > boundaryBottom - 10) || (tagBottom + menuHeight > viewportBottom - 10)) {
        $container.addClass('dropup');
    }
});

// Smart dropdown handling inside .table-responsive:
// 1. Unclip .table-responsive overflow so dropdowns never trigger vertical scrollbars or get cut off
// 2. Automatically flip to dropup (open upwards) if space below in viewport is tight
$(document).on('show.bs.dropdown', function (e) {
    const toggle = e.target;
    if (!toggle) return;
    const dropdown = toggle.closest('.dropdown');
    const tableResponsive = toggle.closest('.table-responsive');

    if (tableResponsive) {
        tableResponsive.style.overflow = 'visible';
    }

    if (dropdown) {
        const toggleRect = toggle.getBoundingClientRect();
        const menuHeight = 280;
        const windowHeight = window.innerHeight || document.documentElement.clientHeight;
        const spaceBelow = windowHeight - toggleRect.bottom;
        const spaceAbove = toggleRect.top;

        if (spaceBelow < menuHeight && spaceAbove > 160) {
            dropdown.classList.add('dropup');
        } else {
            dropdown.classList.remove('dropup');
        }
    }
});

$(document).on('hidden.bs.dropdown', function (e) {
    const toggle = e.target;
    if (!toggle) return;
    const dropdown = toggle.closest('.dropdown');
    const tableResponsive = toggle.closest('.table-responsive');

    if (tableResponsive) {
        tableResponsive.style.overflow = '';
    }
    if (dropdown) {
        dropdown.classList.remove('dropup');
    }
});

// Close open dropdowns if table-responsive is scrolled horizontally
$(document).on('scroll', '.table-responsive', function () {
    const openMenu = this.querySelector('.dropdown-menu.show');
    if (openMenu && typeof bootstrap !== 'undefined' && bootstrap.Dropdown) {
        const toggle = openMenu.closest('.dropdown')?.querySelector('[data-bs-toggle="dropdown"]');
        if (toggle) {
            const inst = bootstrap.Dropdown.getInstance(toggle);
            if (inst) inst.hide();
        }
    }
});

// Initialize notifications
document.addEventListener('DOMContentLoaded', () => {
    initNotifications();
    window.fn_apply_global_tooltips();
});

// export {event_emitter};
// The first steps checklist lives on the dashboard and in the top bar; closing either hides both everywhere.
(() => {
    const FIRST_STEPS_CLOSED_KEY = 'ms_first_steps_closed';
    const CLOSED_CLASS = 'ms-first-steps-closed';
    try {
        if (localStorage.getItem(FIRST_STEPS_CLOSED_KEY) === '1') {
            document.documentElement.classList.add(CLOSED_CLASS);
        }
    } catch (error) {
        // without storage the checklist simply stays until its steps are done
    }

    document.addEventListener('click', event => {
        if (!event.target.closest('[data-first-steps-close]')) {
            return;
        }
        try {
            localStorage.setItem(FIRST_STEPS_CLOSED_KEY, '1');
        } catch (error) {
            // closing still works for this page view
        }
        document.documentElement.classList.add(CLOSED_CLASS);
    });

    // the icon moves like the bell does, until the person opens the list once in this session
    const SEEN_KEY = 'ms_first_steps_seen';
    const icon = document.getElementById('first-steps-icon');
    const button = document.getElementById('page-header-first-steps');
    if (!icon || !button) {
        return;
    }
    let seen = false;
    try {
        seen = sessionStorage.getItem(SEEN_KEY) === '1';
    } catch (error) {
        // without storage the icon simply stays still
        seen = true;
    }
    if (!seen) {
        icon.classList.add('bx-tada');
    }
    button.addEventListener('show.bs.dropdown', () => {
        icon.classList.remove('bx-tada');
        try {
            sessionStorage.setItem(SEEN_KEY, '1');
        } catch (error) {
            // it stops for this page view anyway
        }
    });
})();
